import User from './user';

export default class LoggedInUser {
  constructor(public lastLoginDate: Date,
    public user: User) { }

  static  createFromRequest(request: any): LoggedInUser {
    const { lastLoginDate } = request;
    return new LoggedInUser(lastLoginDate, User.createFromRequest(request.user));
  }
}



// WEBPACK FOOTER //
// ./src/models/loggedInUser.ts